module.exports = __webpack_public_path__ + "img/ok-circle.d347d325.svg";